(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('SiteLocationDeleteController',SiteLocationDeleteController);

    SiteLocationDeleteController.$inject = ['$uibModalInstance', 'entity', 'SiteLocation'];

    function SiteLocationDeleteController($uibModalInstance, entity, SiteLocation) {
        var vm = this;

        vm.siteLocation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SiteLocation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
